module.exports = __webpack_public_path__ + "static/works-snuzi-site-55a6e3631aba5b2497d2763060406efb.png";